import React from 'react';
import { Trans } from 'react-i18next';
import { Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const CommercialSizeHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="commercial_size" t={t}>
      <Box mt={4} mb={2}>
        <Subtitle margined>
          In manchen Fällen
          <b>unterscheidet</b>
          sich die in der Nebenkostenabrechnung angegebene Fläche der Gewerberäumlichkeiten von der im Mietvertrag
          angegebenen Fläche.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Dabei können Diskrepanzen der Werte durchaus nachteilig für Sie sein. Um zu prüfen, dass die Kosten hier nach
          der korrekten Quadratmeter-Anzahl umgelegt wurden, bitten wir Sie um Angabe der Fläche.
        </Subtitle>
      </Box>
      <Box mb={2}>
        <Subtitle>
          <b>Bitte tragen Sie die Quadratmeterzahl ein, die in Ihrer Nebenkostenabrechnung angegeben ist.</b>
        </Subtitle>
      </Box>
    </Trans>
  );
};
export default CommercialSizeHelp;
